<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="2" @click="toNewRouter('check-in-application')">
        <i class="el-icon-damai-shenqing"></i>
        <span slot="title">入住申请</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('check-in-verification')">
        <i class="el-icon-damai-flink_rukuchenggong-icon"></i>
        <span slot="title">入住核验</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('check-in-bill')">
        <i class="el-icon-damai-ruzhuzhangdan"></i>
        <span slot="title">入住账单</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('hotel-check-in-log')">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
<!--
      <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  2: "check-in-application",
  3: "check-in-verification",
  4: "check-in-bill",
  6: "hotel-check-in-log",
});

export default {
  name: "hotelCheckInNav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/hotelCheckIn/hotelCheckInNav.vue